import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "请选择", -1)
const _hoisted_3 = ["value", "selected"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("select", {
    id: _ctx.id,
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    "data-trigger": "manual"
  }, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (item) => {
      return (_openBlock(), _createElementBlock("option", {
        key: item.key,
        value: item.key,
        selected: $props.modelValue === item.key
      }, _toDisplayString(item.value), 9, _hoisted_3))
    }), 128))
  ], 8, _hoisted_1))
}